module.exports = ".titulo {\n  padding: 12px;\n  background-color: #006272;\n  color: #ffffff;\n  width: 100%;\n  text-align: center; }\n\ntextarea {\n  height: 100px;\n  resize: vertical; }\n\n.mat-form-field {\n  width: 100% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/contact-dialog/contact-dialog.component.scss
// module id = ./src/app/main/contact-dialog/contact-dialog.component.scss
// module chunks = main